import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { TooltipProvider } from "@/components/ui/tooltip";
import { bootstrapSession, sessionLost } from "@/lib/session";
import { initTheme } from "@/lib/theme";
import { vaultStore } from "@/lib/vault-store";
import { routeTree } from "./routeTree.gen";
import "./styles.css";

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 10_000, refetchOnWindowFocus: false } },
});

const router = createRouter({ routeTree, context: { queryClient }, defaultPreload: "intent", scrollRestoration: true });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

initTheme();
vaultStore.onRevoked = () => {
  sessionLost();
  void router.navigate({ to: "/login", search: { redirect: undefined, reason: "revoked" } });
};

const root = document.getElementById("root");
if (!root) throw new Error("missing #root");

void bootstrapSession().finally(() => {
  createRoot(root).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <RouterProvider router={router} />
        </TooltipProvider>
      </QueryClientProvider>
    </StrictMode>,
  );
});
